import React, {Component} from "react";
import Group, {GroupDescription, GroupHead} from "../../../Components/Group";
import Button from "../../../Components/Control/Button";
import './index.css';
import Grid from "../../../Components/Grid";
import Resource from "../../../Resource";
import {Tool} from "../../../App";
import Configuration from "../../../Server/Configuration";
import {connect} from "react-redux";
import {updateBase} from "../../../Redux/Actions/base";
import ModalRole from "../../Modal/ModalRole";
import {ModalAction} from "../../../Components/Modal";
import Perms from '../../../Perms';

class PageRoles extends Component {
    constructor (props) {
        super(props);

        if (!Perms().CONFIGURATION.ROLES.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        console.log(Perms().CONFIGURATION.ROLES.VIEW);
        this.state = {
            grid: {
                columnDefs: [{
                    field: 'roleStr',
                    headerName: 'نام نقش',
                    headerTooltip: 'نام نقش',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    pinned: 'right',
                    filter: 'agTextColumnFilter'
                }],
                frameworkComponents: {
                    access: row => <button className={row.value ? 'access granted' : 'access denied'}></button>
                },
                onRowDoubleClicked: row => {
                    this.ref.modalRole.current.open(row.data, Perms().CONFIGURATION.ROLES.UPDATE ? ModalAction.UPDATE : ModalAction.VIEW);
                }
            },
            rowData: [],
            selectedRows: [],
            roleGrid: null
        };

        this.ref = {
            roleGrid: React.createRef(),
            modalRole: React.createRef()
        };
    }

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    componentDidMount () {
        Configuration.accessList()
            .then(list => {
                const columns = [...this.state.grid.columnDefs];

                columns.push(...list.map(item => {
                    return {
                        headerName: item.menuStr,
                        children: (item.menuActions || []).map(item => {
                            return {
                                headerName: item.menuActionStr,
                                headerTooltip: item.menuActionStr,
                                data: item,
                                valueGetter: row => {
                                    const actionId = row.colDef.data.menuActionId;
                                    const search = row.data.menues.find(item => item.menuActions.find(item => item.menuActionId === actionId));
                                    return Boolean(search);
                                },
                                cellRenderer: 'access'
                            };
                        })
                    };
                }));

                this.setState({
                    accessList: list,
                    grid: {
                        ...this.state.grid,
                        columnDefs: columns
                    }
                });
            });

        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    render () {
        return <React.Fragment>
            <Group className={'PageRoles-group mar-10'}>
                <GroupHead title={'لیست نقش‌ها'}>
                    {Perms().CONFIGURATION.ROLES.INSERT && <Button className={'mar-s-4'} theme={'blue'} onClick={this.addClickHandler.bind(this)}>افزودن نقش</Button>}
                </GroupHead>
                <GroupDescription>لیست نقش‌های داخل سامانه از این قسمت قابل مشاهده می باشد.</GroupDescription>
                <Grid  refer={this.ref.roleGrid} id={'hospitals'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.roleGridReadyHandler.bind(this)} onSelectionChanged={this.roleGridSelectionHandler.bind(this)}/>
            </Group>
            <ModalRole refer={this.ref.modalRole} onSuccess={this.updateGrid.bind(this)}/>
        </React.Fragment>;
    }

    addClickHandler () {
        this.ref.modalRole.current.open(null, ModalAction.INSERT);
    }

    roleGridReadyHandler (params) {
        this.updateGrid();

        this.setState({roleGrid: params});
    }

    roleGridSelectionHandler (rows) {
        this.setState({selectedRows: rows});
    }

    updateGrid () {
        this.ref.roleGrid.current.loading();

        Configuration.rolesList()
            .then(list => {
                this.setState({rowData: list}, _ => {
                    this.ref.roleGrid.current.loading(false);
                });
            })
            .catch(message => {
                this.ref.roleGrid.current.error();
            });
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageRoles);